module.exports = __webpack_public_path__ + "static/media/IMG_20191127_125806.02a90cba.jpg";